import { ReturnTo } from "@ai-platform/contracts";

/**
 * A return path from a query string, if it is a relative path in the sense of the contract
 * (07 §2.3); anything else is dropped, so no link can send the user to another site.
 */
export function safeReturnPath(value: unknown): string | undefined {
  const parsed = ReturnTo.safeParse(value);
  return parsed.success ? parsed.data : undefined;
}
